<template>
  <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition">
    <template v-slot:activator="{ attrs }">
      <!-- v-on="on" -->
      <v-btn
        small
        color="success"
        v-bind="attrs"
        :loading="isloading"
        @click="OpenBalanceDialog"
        icon
      >
        <v-icon>fas fa-eye</v-icon>
      </v-btn>
    </template>
    <v-card v-if="Balance.length">
      <v-card-title class="headline justify-center"
        >{{ Title }}
        <!-- <v-spacer></v-spacer> -->
      </v-card-title>

      <v-card-text class="font-weight-black title text-center">
        <p v-if="Title2" class="success--text hosdhig">{{ Title2 }}</p>
        <template v-for="(item, index) in Balance">
          <p
            v-if="item.Amount != 0"
            :key="index"
            :class="{ 'red--text': item.Amount < 0 ? true : false }"
          >
            {{ item.AmountType }}: {{ item.Amount.toLocaleString() }}
            {{ item.AmountType | MoneySigns }}
          </p>
        </template>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline justify-center">{{ Title }}</v-card-title>

      <v-card-text class="font-weight-black title text-center">
        Empty Balance
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    ReqURL: { type: String, required: true },
    Title: { type: String, required: true },
    Title2: { type: String },
    // item: { type: Object, required: true },
    query: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
      isloading: false,
      Balance: [],
    };
  },
  methods: {
    OpenBalanceDialog() {
      this.isloading = true;
      // },
      // ShowBalance() {
      this.Balance = [];
      // console.log(ID);
      this.$store
        .dispatch("FIND_BY_VALUE", {
          url: this.ReqURL,
          query: this.query,
        })
        .then(result => {
          this.dialog = true;
          this.isloading = false;
          this.Balance = result.data;
          // this.Balance.Name = item.FullName;
          // this.Balance.share = item.share;
        })
        .catch(() => {
          // console.log(error);
          //   this.clickedID = "";
          this.isloading = false;
        });
    },
  },
};
</script>
<style scoped>
.hosdhig {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
